<template>
  <div class="help-list" :class="{ 'locale-zh-CN': isZhLocale }">
    <div 
      v-for="(item, index) in items" 
      :key="item.id || index"
      class="help-item"
      @click="handleItemClick(item)"
    >
      <div class="item-icon">
        <img :src="itemIconSafe" alt="" @error="onImgError" />
      </div>
      <div class="item-content">
        <h4 class="item-title">{{ item.title }}</h4>
        <div class="item-date">{{ item.date }}</div>
      </div>
      <div class="item-bg">
        <img :src="itemBgSafe" alt="" @error="onImgError" />
      </div>
    </div>
  </div>
</template>

<script>
import { localeImg } from '@/utils/localeAsset'
import { getSafeImage, handleImgError } from '@/utils/imageFallback'

export default {
  name: 'HelpList',
  props: {
    // 帮助文章列表数据
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemIcon: localeImg('help/item-left-ico.png'),
      itemBg: localeImg('help/item-bg.png')
    }
  },
  computed: {
    itemIconSafe() {
      return getSafeImage(this.itemIcon)
    },
    itemBgSafe() {
      return getSafeImage(this.itemBg)
    }
  },
  methods: {
    onImgError(event) {
      handleImgError(event)
    },
    handleItemClick(item) {
      this.$emit('item-click', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.help-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
  
  .help-item {
    position: relative;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    border: 1px solid rgba(160, 144, 60, 0.2);
    cursor: pointer;
    transition: all 0.3s;
    overflow: hidden;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-3px);
      border-color: rgba(160, 144, 60, 0.4);
    }
    
    .item-bg {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: auto;
      height: 100%;
      opacity: 1;
      pointer-events: none;
      z-index: 0;
      
      img {
        width: auto;
        height: 100%;
        object-fit: contain;
        object-position: right center;
      }
    }
    
    .item-icon {
      position: relative;
      z-index: 1;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    
    .item-content {
      position: relative;
      z-index: 1;
      flex: 1;
      min-width: 0;
      
      .item-title {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #8E7E29;
        margin: 0 0 8px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.4;
      }
      
      .item-date {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #8E7E29;
      }
    }
  }
}
</style>
